import React, { ReactNode, useEffect, useState } from 'react';
import { logout } from 'api/authService';
import { LANDING } from 'constants/routes';
import { useUser } from 'api/userService';

import { ReactComponent as LogoSVGDesktop } from 'assets/Icon/logo.svg';
import { ReactComponent as LogoSVGMobile } from 'assets/Icon/mobile_logo.svg';
import IconSvg from 'components/ui/IconSvg';
import Avatar from 'components/ui/Avatar';
import BannerSponsor from 'components/ui/BannerSponsor';
import Menu from 'components/ui/Menu';
import { useOptionalTournament, useTournament } from 'context/TournamentContext';

import {
  Wrapper,
  Nav,
  ColLeft,
  ColRight,
  Col,
  BtnLogo,
  BtnLogout,
  IconLogOut,
  PageContent,
  MenuMobile,
} from './styled';

interface Props {
  children: ReactNode;
  compact?: boolean;
}

const BaseWrapper = ({ children, compact = false }: Props) => {
  const { isLoggedIn } = useUser();
  const tournamentContext = (useOptionalTournament ?? useTournament)();
  const tournamentDetails = tournamentContext?.tournamentDetails;
  const [isAnonymousUser, setAnonymousUser] = useState(false);
  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData;
  const tournamentAnonymousUsers = attributes?.allow_anonymous_users;
  const tournamentId = rawData?.id;

  useEffect(() => {
    if (tournamentAnonymousUsers === false ) {
      setAnonymousUser(false);
    }
    if (tournamentAnonymousUsers === true ) {
      setAnonymousUser(true);
    }
  }, [tournamentAnonymousUsers]);

  const handleLogoutClick = () => {
    logout();
  };
  let button;
  if (isLoggedIn) {
    button = <>Logout <IconLogOut></IconLogOut></>;
  } else {
    button = <>Log In <IconLogOut></IconLogOut></>;
  }
  return (
    <Wrapper $compact={compact}>
      <Nav $compact={compact}>
        <ColLeft $compact={compact}>
          <Col>
            <BtnLogo to={LANDING}>
              <IconSvg className="svgDesktop" width={140} Icon={LogoSVGDesktop} />
              <IconSvg className="svgMobile"  width={65} Icon={LogoSVGMobile} />
            </BtnLogo>
            {isLoggedIn &&<Avatar />}
          </Col>
          <Col className="center">
            {tournamentId != null && <BannerSponsor />}
          </Col>
          <Col className="menuCol">
            <div className="menuWrap">
              <Menu />
            </div>
            <BtnLogout className="btnLog" onClick={handleLogoutClick} to={LANDING}>
              {button}
            </BtnLogout>
          </Col>
        </ColLeft>
        <ColRight $compact={compact}>
          <BtnLogout onClick={handleLogoutClick} to={LANDING}>
            {button}
          </BtnLogout>
        </ColRight>
      </Nav>
      <MenuMobile>
        <Menu />
      </MenuMobile>
      <PageContent>
        <>{children}</>
      </PageContent>
    </Wrapper>
  );
}

export default BaseWrapper;
